const data = {
  id: 1,
  title: 'Listen and choose the sentence that has the falling intonation.',
  subTitle: 'Nghe và chọn câu có ngữ điệu rơi.',
  question: 'Rising',
  answers: [
    { id: 1, answer: '', isCorrect: true, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/7efb625f-d07c-446d-a1db-0ba7caeb51d1.mp3' },
    { id: 2, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/87bbc2d9-5446-4415-9080-05e468ea79f1.mp3' },
    { id: 3, answer: '', isCorrect: false, audioUrl: 'https://cloud.softech.cloud/storage/Data/Sentences/14ff82a6-8780-4495-8f23-8f1502aca4e4.mp3' },
  ],
};

export default data;
